import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRadio } from "@/context/RadioContext";
import { Radio, Play, Pause, X, Loader2 } from "lucide-react";

export function RadioBar() {
  const { available, config, playing, loading, nowTitle, toggle } = useRadio();
  const [min, setMin] = useState(() => typeof window !== "undefined" && window.innerWidth < 640);
  const location = useLocation();
  if (!available || location.pathname === "/onair") return null;

  if (min) {
    return (
      <button onClick={() => setMin(false)} data-testid="radio-bar-mini"
        className="fixed bottom-5 right-5 z-[80] w-12 h-12 rounded-full bg-navy text-bone shadow-xl flex items-center justify-center hover:bg-charcoal transition-colors">
        <Radio size={18} />
        {playing && <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-rust animate-pulse" />}
      </button>
    );
  }

  return (
    <div data-testid="radio-bar" className="fixed bottom-5 right-5 z-[80] bg-navy text-bone shadow-2xl border border-white/10 w-[300px] max-w-[calc(100vw-2.5rem)]">
      <div className="flex items-center gap-3 p-3">
        <button onClick={toggle} data-testid="radio-bar-play" aria-label={playing ? "Pause radio" : "Play radio"}
          className="w-11 h-11 rounded-full bg-gold text-navy flex items-center justify-center hover:scale-105 transition-transform shrink-0">
          {loading ? <Loader2 size={17} className="animate-spin" /> : playing ? <Pause size={17} /> : <Play size={17} className="ml-0.5" />}
        </button>
        <Link to="/onair" className="flex-1 min-w-0 group" data-testid="radio-bar-link">
          <span className="flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-gold">
            <span className={`w-1.5 h-1.5 rounded-full ${playing ? "bg-rust animate-pulse" : "bg-bone/40"}`} /> On the Air
          </span>
          <span className="font-sans text-sm block truncate group-hover:text-gold transition-colors" data-testid="radio-bar-title">
            {playing && nowTitle ? nowTitle : config?.station_name || "IHIMM Radio"}
          </span>
        </Link>
        <button onClick={() => setMin(true)} data-testid="radio-bar-minimize" aria-label="Minimize radio" className="text-bone/50 hover:text-bone p-1 shrink-0"><X size={15} /></button>
      </div>
    </div>
  );
}
